export default __webpack_public_path__ + "b4400c9936041745ec3ee70716fd1b69.svg";